import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-load-selection-modal',
  templateUrl: './load-type-selection-modal.component.html'
})
export class LoadTypeSelectionModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  select(option: 'A' | 'B') {
    this.activeModal.close(option);
  }
}
